import React from 'react';
import Department from 'material-ui/svg-icons/social/location-city';
import { push } from 'react-router-redux';
import { change } from 'redux-form';
import {
  setDepartments,
  setDepartmentList,
  setSelectedDepartment,
} from '../../redux/department/actions';

const changeValues = (dispatch, values) => {
  for (const field in values) {
    dispatch(change('modifyDepartment', field, values[field]));
  }
};

const getListProps = (dispatch, departments, props) => {
  const result = {
    title: 'DEPARTMENTS',
    items: [],
  };
  for (let i = 0; i < departments.length; i++) {
    result.items.push({
      key: departments[i].id,
      icon: <Department />,
      primaryText: departments[i].name,
      editable: false,
      deletable: false,
      onTouchTap: () => {
        dispatch(setSelectedDepartment(departments[i]));
        if (props.navigate) {
          dispatch(push('/department'));
        }
        changeValues(dispatch, departments[i]);
      },
    });
  }
  return result;
};

export const onSuccess = (result, dispatch, props) => {
  dispatch(setDepartments(result.body.resultSet));
  dispatch(setDepartmentList(getListProps(dispatch, result.body.resultSet, props)));
  dispatch(setSelectedDepartment(result.body.resultSet[0]));
  changeValues(dispatch, result.body.resultSet[0]);
};

export const onModificationSuccess = (result, dispatch) => {
  dispatch(setSelectedDepartment(result.body));
};



/** WEBPACK FOOTER **
 ** ./src/routes/Department/util.js
 **/